module.exports = __webpack_public_path__ + "static/media/badge_aws.64ddadaf.png";